import React from 'react';

import avtalegiroReducer from '../../components/transaction/AvtaleGiro/form/reducer';
import { getInitialState } from '../../components/transaction/AvtaleGiro/form/state';
import { AvtalegiroFormContext } from '../../components/transaction/AvtaleGiro/form/useFormContext';
import validate from '../../components/transaction/AvtaleGiro/form/validate';
import { SelectedReceiver } from '../../components/transaction/SelectedReceiver';
import type { AvtalegiroAgreementDetails, PaymentAgreementId, PaymentItem } from '../../generated-types';
import StoppedAvtalegiroFormContent from './StoppedAvtalegiroFormContent';
import StoppedAvtalegiroFormSkeleton from './StoppedAvtalegiroFormSkeleton';

import './StoppedAvtalegiroForm.scss';

type Props = {
    paymentItem: PaymentItem;
    optimisticAvtalegiroDetails: AvtalegiroAgreementDetails | undefined;
    receiver: SelectedReceiver | undefined;
    onClose: () => void;
    avtalegiroId: PaymentAgreementId | undefined;
    setIsSuccess: (value: boolean) => void;
    isLoading: boolean;
};

const StoppedAvtalegiroForm: React.FC<Props> = ({
    paymentItem,
    optimisticAvtalegiroDetails,
    receiver,
    onClose,
    avtalegiroId,
    setIsSuccess,
    isLoading,
}) => {
    if (isLoading) return <StoppedAvtalegiroFormSkeleton />;
    if (!optimisticAvtalegiroDetails || !avtalegiroId) return null;

    return (
        <AvtalegiroFormContext
            validateHook={validate}
            reducer={avtalegiroReducer}
            initialState={getInitialState(optimisticAvtalegiroDetails, receiver)}
        >
            <StoppedAvtalegiroFormContent
                paymentItem={paymentItem}
                avtalegiroId={avtalegiroId}
                receiver={receiver}
                avtalegiroDetails={optimisticAvtalegiroDetails}
                onClose={onClose}
                setIsSuccess={setIsSuccess}
            />
        </AvtalegiroFormContext>
    );
};
export default StoppedAvtalegiroForm;
